import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CoerceBoolean} from '../../../../shared/utils/coercion.utils';
import {AbstractControl, FormControl} from "@angular/forms";
import {FormUtils} from "../../../../shared/utils/form.utils";

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent implements OnInit, OnChanges{

  @Input() label: string;
  @Input('required') @CoerceBoolean() _required = false;
  @Input() size: number;
  @Input() sizeLg: number;
  @Input() sizeXl: number;
  @Input() compact = false;
  @Input() fieldFormControl: AbstractControl;

  required = false;

  ngOnInit(): void {
    if (this.noSizeSpecified()) {
      this.size = 12;
      this.sizeLg = 4;
      this.sizeXl = 2;
    } else {
      if (!this.size) {
        this.size = 12;
      }
      if (!this.sizeLg) {
        this.sizeLg = this.size;
      }
      if (!this.sizeXl) {
        this.sizeXl = this.size;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['_required'] || changes['formControl']) {
      this.required = this._required === true || (this.fieldFormControl && FormUtils.isRequiredField(this.fieldFormControl));
    }
  }

  private noSizeSpecified() {
    return !this.size && !this.sizeLg && !this.sizeXl;
  }

}
